import { render, staticRenderFns } from "./ChartReferralPhase.vue?vue&type=template&id=94d2dfe2&"
import script from "./ChartReferralPhase.vue?vue&type=script&lang=ts&"
export * from "./ChartReferralPhase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports